export const SHOW_TURNTABLE = 'SHOW_TURNTABLE_NBA'
export const SET_TURNTABLE_SIZE = 'SET_TURNTABLE_SIZE_NBA'
export const SET_RESULT_SELECTED = 'SET_RESULT_SELECTED_NBA'
export const SET_MODE = 'SET_MODE_NBA'
export const SET_CHOICES = 'SET_CHOICES_NBA'
export const SET_HISTORY = 'SET_HISTORY_NBA'
export const SET_CONFERENCE_ACTIVE = 'SET_CONFERENCE_ACTIVE_NBA'
export const SET_SHOW_MODE = 'SET_SHOW_MODE_NBA'
export const SET_TITLE_OBJ = 'SET_TITLE_OBJ_NBA'
export const INSTANT_INIT = 'INSTANT_INIT_NBA'
export const RESET_INITIAL_STATE = 'RESET_INITIAL_STATE_NBA'
export const REPLACE_STATE = 'REPLACE_STATE_NBA'
export const SET_TEAMS_ACTIVE = 'SET_TEAMS_ACTIVE_NBA'
export const SET_MYSTERY_WHEEL_ON = 'SET_MYSTERY_WHEEL_ON_NBA'
export const SET_MYSTERY_RESULT_ON = 'SET_MYSTERY_RESULT_ON_NBA'
export const UPDATE_MYSTERY_SETTINGS = 'UPDATE_MYSTERY_SETTINGS_NBA'
export const SET_SCORES = 'SET_SCORES_NBA'
export const SET_AUTO_ADD_COUNT = 'SET_AUTO_ADD_COUNT_NBA'
